import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { EllipsisText } from '@vk-hr-tek/ui/EllipsisText';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Tooltip } from '@vk-hr-tek/ui/Tooltip';
import { IconButton } from '@vk-hr-tek/ui/IconButton';
import { Icon as ImportedIcon } from '@vk-hr-tek/ui/Icon';

import { useStyles } from './NotificationItemBody.styles';

interface NotificationItemBodyProps {
  variant: 'list' | 'widget';
  message: string;
  read: boolean;
  onRead: () => void;
  onTooltipOpen: () => void;
  onTooltipClose: () => void;
}

export const NotificationItemBody = ({
  variant,
  message,
  read,
  onRead,
  onTooltipOpen,
  onTooltipClose,
}: NotificationItemBodyProps) => {
  const { classes } = useStyles();

  const isWidget = variant === 'widget';

  return (
    <Box
      display="flex"
      alignItems="start"
      justifyContent="space-between"
      gap="4"
    >
      {isWidget ? (
        <EllipsisText wordBreak="break-word">
          <Typography variant="body3">{message}</Typography>
        </EllipsisText>
      ) : (
        <Typography variant="body3" className={classes.messageWrapper}>
          {message}
        </Typography>
      )}
      <Tooltip
        placement="bottom"
        title="Отметить прочитанным"
        disabled={read}
        onOpen={onTooltipOpen}
        onClose={onTooltipClose}
      >
        <Box display="flex" {...(read && { visibility: 'hidden' })}>
          <IconButton
            size="medium"
            disableRipple
            onClick={onRead}
            className={classes.iconButtonWrapper}
          >
            <ImportedIcon
              name="circle_small_filled"
              size="24"
              color="accent.text.error"
            />
          </IconButton>
        </Box>
      </Tooltip>
    </Box>
  );
};
